import EnquiriesManagement from '../EnquiriesManagement';

const BusinessEnquiries = () => {
  return <EnquiriesManagement serviceType="business" />;
};

export default BusinessEnquiries;